<span class="d-block badge badge-info origem mt-1" *ngIf="pedido?.origem"
      [ngClass]="{'badge-danger' : pedido.doIfood, 'badge-warning': pedido.balcao || pedido.do99food,
                   'badge-dark' : pedido.doKeeta , 'badge-primary': pedido.doOpenDelivery,
                   'text-black': pedido.do99food, 'badge-mia': viaMia}">
        <ng-container *ngIf="viaMia">via Mia 🤖</ng-container>
        <ng-container *ngIf="!viaMia && pedido.origem !== 'REPOSICAO_INTERNA'">{{pedido.origem}}</ng-container>
        <ng-container *ngIf="pedido.origem === 'REPOSICAO_INTERNA'">Reposição interna</ng-container>
</span>
<span class="d-block badge origem mt-1" *ngIf="pedido?.doOpenDelivery && pedido?.parceiro"
      [class.badge-primary]="!parceiroAiqfome" [class.badge-aiqfome]="parceiroAiqfome">
        {{parceiroAiqfome ? 'aiqfome' : pedido.parceiro}}
</span>
